import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_HuffmanCoding = () => (
  <DAAModuleSubtopic
    title="Greedy Algorithm – Huffman Coding"
    videos={[
      "https://www.youtube.com/embed/co4_ahEDCho",
      "https://www.youtube.com/embed/saofdNsZiYY",
      "https://www.youtube.com/embed/u_yLtJCjzb0"
    ]}
    takeaways={[
      { text: "Time Complexity: O(n log n), where n is the number of unique characters." },
      { text: "Applications: File compression algorithms (ZIP, GZIP), Multimedia codecs (JPEG, MP3, MPEG), Efficient data transmission." }
    ]}
    questions={[
      {
        text: "Demonstrate how the Huffman code is used to compress data. Consider the string 'BCAADDDCCACACAC'. Compress it and calculate the minimum number of bits required for transmission. Include the algorithm and time complexity analysis."
      },
      {
        text: "For the phrase 'wearetryingtolearndesignandanalysisofalgorithm', construct the Huffman coding and generate the code for the word 'Tester'. Compare the length of the fixed and variable-length codes for the word 'Tester'."
      },
      {
        text: "Consider the string 'shesellsseashellsbytheseashores'. Use Huffman coding to calculate the number of bits required to encode it. Identify the bits required in both fixed-size and variable-length encoding."
      },
      {
        text: "Discuss how the greedy approach is used in optimization problems. Construct the frequency table of characters in 'Hi! How are you?' in non-decreasing order of frequency. Use Huffman code to find the code word for each character."
      },
      {
        text: "A file contains characters with frequencies. If Huffman coding is used for data compression, determine the Huffman code for each character, the average code length, and the length of the encoded message in bits.",
        image: "/Huff1.png"
      },
      {
        text: "Elaborate the optimal substructure property of Huffman coding. Construct the frequency table of characters in 'mississippi' in non-decreasing order of frequency. Use the Huffman coding method to find the code word for each character."
      },
      {
        text: "Consider the string 'abbccddeeef'. Each letter must be assigned a binary code. Generate the code word for each character by constructing the Huffman tree. i) Find the minimum length of the encoded string. ii) Decode the string '10110011101'."
      },
      {
        text: "Write the pseudo code for constructing the Huffman tree using the greedy method."
      },
      {
        text: "Develop the Huffman codes for data given below when transmitted from transmitter to receiver ",
        image: "/Huff2.png"
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/uDS8AkTAcIU",
      "https://www.youtube.com/embed/ocFO1rmh4Zc",
      "https://www.youtube.com/embed/qPIyFx1fexs",
      "https://www.youtube.com/embed/VGOtFQpk6bQ",
      "https://www.youtube.com/embed/swus_TH6sk8"
    ]}
  />
);

export default DAA_HuffmanCoding ;
